// CheckoutSuccess.tsx
import React, { useEffect, useState } from 'react';
import '../styles/CheckoutSuccess.css';
import { API_URL } from '../config';

const CheckoutSuccess: React.FC = () => {
  const [mensaje, setMensaje] = useState('Confirmando tu orden...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const metodo = params.get('metodo'); // 'mercadopago' | 'transferencia' | 'efectivo'
    const externalRef = params.get('external_reference');
    const paymentId = params.get('payment_id');
    const ordenId = params.get('orden_id');

    let url = '';

    if (metodo === 'mercadopago' && externalRef && paymentId) {
      url = `${API_URL}/api/pago_exitoso/?external_reference=${externalRef}&payment_id=${paymentId}`;
    } else if (metodo === 'transferencia' && ordenId) {
      url = `${API_URL}/api/orden_transferencia_exitosa/?orden_id=${ordenId}`;
    } else if (metodo === 'efectivo' && ordenId) {
      url = `${API_URL}/api/orden_efectivo_exitosa/?orden_id=${ordenId}`;
    } else if (metodo === 'flow') {                                                                                                 
       setMensaje('✅ Tu pago está siendo procesado.\nTe confirmaremos por email cuando sea aprobado.');                             
       return;   
    } else {
      setMensaje('No se pudo identificar la orden.');
      return;
    }

    fetch(url)
      .then(res => res.json())
      .then(data => setMensaje(data.message ?? 'No se pudo confirmar la orden.'))
      .catch(() => setMensaje('Error al verificar el estado de la orden.'));
  }, []);

  return (
  <div className="checkout-success">
  <h2>
    {mensaje.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ))}
  </h2>
</div>


  );
};

export default CheckoutSuccess;
